import { styled } from '@mui/material';
import { colorPalettes } from '../../../context/theme';
import { Button } from '../../base/Button';

export const StyledActionButton = styled(Button)`
  border: 1px solid
    ${({ theme }) =>
      colorPalettes[theme.palette.mode].components.DropDown.border.color};
  border-radius: 0px 3px 3px 0px;
  border-left: none;
  :hover {
    border-left: none;
    background-color: ${({ theme }) =>
      colorPalettes[theme.palette.mode].components.DropDown.item.selected
        .color};
  }
  padding: 1rem;
  min-width: unset;
  background-color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.DropDown.background.color};
`;

export const StyledSortableDropdown = styled.div`
  display: flex;

  > :nth-of-type(1) {
    border-end-end-radius: 0;
    border-start-end-radius: 0;
  }

  :focus-within {
    background-color: unset;
  }
`;
